require('../components/blog.js');
require('../components/slideshow.js');
require('../components/statistics.js');
require('../components/text_cards.js');